// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"15":"ResetPasswordUpdatePage","935":"ResetPasswordRequestPage"}[chunkId] + "." + {"15":"c3356497","935":"c3356497"}[chunkId] + ".chunk.css";
};